import React from 'react';

var CloneByVersionPopup = React.createClass({
  getInitialState: function(){
    return {value: "Select One", msg: "", showDropdown: false}
  },
  componentDidMount: function() {
    // $('.modal__content').css({'position': 'fixed'});
  },
  handleCloseClick: function(){
    this.props.cloneByVersionPopup();
  },
  handleSubmitClick: function(){
    if(this.state.value === "Select One"){
      this.setState({msg: "Please select a version."});
    } else {
      this.setState({msg: ""});
      this.props.cloneByVersion(this.state.value);
    }
  },
  handleVersionClick: function(value){
    this.setState({msg: "", value: value, showDropdown: false});
  },
  handleValueClick: function(e){
    e.stopPropagation();
    this.setState({showDropdown: !this.state.showDropdown});
  },
  handleOutsideClick: function(e){
    e.stopPropagation();
    /* close dropdown when click outside */
    this.setState({showDropdown: false});  
  },
  render: function(){
    var versions = [1,2,3,4,5];
    var values = versions.map((value, index) =>
      <li key = {index}>
        <a href="javascript:void(0)" onClick = {this.handleVersionClick.bind(this, value)}>
          <span className="value">{value}</span>
        </a>
      </li>
      );
    return(
      <div className="modal__mask" onClick = {this.handleCloseClick}>
        <div className="modal__content modal--md" onClick = {this.handleOutsideClick}>
          <div className="modal__header">
            <h3 className="modal__header--title">Clone Install</h3>
            <a href="javascript:void(0)" className="modal__close"><i className="fa  fa-close" onClick = {this.handleCloseClick}> </i></a> </div>
          <div className="modal__body clearfix">
            <div className="form__row clearfix">
              <p>Select the version that you would like to clone onto your machine.</p>
            </div>
            <p style = {{color: "red"}}>{this.state.msg}</p>
            <div className="form__row clearfix">
                <div className="custom-dropdown custom-dropdown--black">
                      <dl className="dropdown">
                        <dt>
                          <a href="javascript:void(0)" onClick = {this.handleValueClick}><span className="value">{this.state.value}</span></a>
                        </dt>
                        { this.state.showDropdown ?
                        <dd>
                          <ul>
                            {values}
                          </ul>
                        </dd> : null }
                      </dl>
                </div>
            </div>
            <div className="buttons clearfix">      
              <button className="btn__md bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
              <button className="btn__md bg-dark" onClick = {this.handleSubmitClick}>Clone</button>
            </div>
          </div>  
        </div>
      </div>
    );
  }
});

export {CloneByVersionPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/CloneByVersionPopup.jsx
 **/